var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBuilder24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_builder24x24",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M430.382,673H428.6l-.361-1h-6.562l-.361,1h-1.779a.5.5,0,1,0,0,1h10.84a.527.527,0,0,0,.565-.48.519.519,0,0,0-.519-.521Z",
    transform: "translate(-415.963 -658.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M899.5,144a.5.5,0,1,0,.5.5h0A.5.5,0,0,0,899.5,144Z",
    transform: "translate(-885.211 -141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M289.8,0H275a1.545,1.545,0,0,0-1.582,1.5v8.511h3.2v-1.5a.515.515,0,0,1,.527-.5h.816a4.332,4.332,0,0,1,.187-.429l-.577-.55a.483.483,0,0,1,0-.707l0,0,1.491-1.409a.547.547,0,0,1,.745,0l.005,0,.577.547a4.85,4.85,0,0,1,.452-.178V4.506a.514.514,0,0,1,.522-.5h2.109a.515.515,0,0,1,.527.5V5.28q.231.078.452.178l.577-.547a.547.547,0,0,1,.747,0l0,0,1.492,1.416a.483.483,0,0,1,.005.707l-.005,0-.577.547a4.348,4.348,0,0,1,.188.429h.815a.515.515,0,0,1,.527.5v1.5h3.195V1.5A1.577,1.577,0,0,0,289.8,0Zm-2.109,5.007a1.544,1.544,0,0,1-1.582-1.5,1.584,1.584,0,0,1,3.164,0h0A1.545,1.545,0,0,1,287.693,5.006Z",
    transform: "translate(-273.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M611,385.566a1.493,1.493,0,0,0,.1.5h2.81a1.5,1.5,0,1,0-2.907-.5Z",
    transform: "translate(-603.502 -376.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M468.242,243.63a.545.545,0,0,1-.534.375H467v1h2.278a2.4,2.4,0,0,1,1.124-2.642,2.99,2.99,0,0,1,3.119,0,2.4,2.4,0,0,1,1.125,2.642h2.278v-1h-.71a.545.545,0,0,1-.534-.375,3.278,3.278,0,0,0-.407-.89.467.467,0,0,1,.085-.608l.5-.456-.784-.712-.5.456a.591.591,0,0,1-.67.077,4.011,4.011,0,0,0-.98-.37.512.512,0,0,1-.413-.485V240h-1.1v.643a.512.512,0,0,1-.413.485,4,4,0,0,0-.98.37.591.591,0,0,1-.67-.077l-.5-.456-.784.712.5.456a.467.467,0,0,1,.085.608A3.277,3.277,0,0,0,468.242,243.63Z",
    transform: "translate(-462.961 -235.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M273.4,528.5a1.545,1.545,0,0,0,1.582,1.5h14.8a1.577,1.577,0,0,0,1.617-1.5V528h-18Z",
    transform: "translate(-273.4 -517.003)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBuilder24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_builder24x24.c5e9757be32d134239296db34f25c8ec.svg";